import { render, staticRenderFns } from "./RiskHiddenDanger.vue?vue&type=template&id=3fef00e8&scoped=true"
import script from "./RiskHiddenDanger.vue?vue&type=script&lang=js"
export * from "./RiskHiddenDanger.vue?vue&type=script&lang=js"
import style0 from "./RiskHiddenDanger.vue?vue&type=style&index=0&id=3fef00e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fef00e8",
  null
  
)

export default component.exports